import { useState } from 'react';
import { LegalDisclosure } from './LegalDisclosure';
import { WelcomeMessage } from './WelcomeMessage';

export const FBDIWelcome = ({ startApplicationHandler }: { startApplicationHandler: () => void }) => {
  const [step, setStep] = useState(1);

  return (
    <div className='containter mx-auto bg-white rounded-md py-4 max-w-6xl'>
      {step === 1 && <WelcomeMessage setStep={() => setStep(2)} />}
      {step === 2 && <LegalDisclosure startApplicationHandler={startApplicationHandler} />}
    </div>
  );
};
